/**
 * 防抖函数，用于限制函数的执行频率
 * @param {Function} fn - 需要防抖的函数
 * @param {number} delay - 延迟时间（毫秒）
 * @param {boolean} immediate - 是否立即执行
 * @returns {Function} - 防抖处理后的函数
 */
export function debounce(fn, delay = 300, immediate = false) {
    let timer = null;

    return function (...args) {
        if (timer) {
            clearTimeout(timer);
        }

        if (immediate) {
            // 立即执行模式：第一次点击立即执行，后续点击延迟执行
            const shouldExecute = !timer;
            timer = setTimeout(() => {
                timer = null;
            }, delay);
            if (shouldExecute) {
                fn.apply(this, args);
            }
        } else {
            // 非立即执行模式：所有点击都延迟执行
            timer = setTimeout(() => {
                fn.apply(this, args);
                timer = null;
            }, delay);
        }
    };
}

/**
 * 防抖点击hooks方法
 * @param {Function} fn - 点击事件处理函数
 * @param {number} delay - 延迟时间（毫秒）
 * @param {boolean} immediate - 是否立即执行
 * @returns {Function} - 防抖处理后的点击事件处理函数
 */
export function useDebounceClick(fn, delay = 300, immediate = true) {
    return debounce(fn, delay, immediate);
}
